export const SET_COUNTRIES = 'SET_COUNTRIES';

export function setCountries(payload) {
  return { type: SET_COUNTRIES, payload };
}
